import "./App.scss";
import React from "react";
import MyRouter from "./routes/Routes";
import { BrowserRouter } from "react-router-dom";
import AppModal from "../src/components/popup";
import RedirectMiddleware from "./components/RedirectMiddleware";
import { SITE_KEY } from "./config/config";

// import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

function App() {
  return (
    <>
      {/* <GoogleReCaptchaProvider
        reCaptchaKey={SITE_KEY}
        scriptProps={{
          async: true,
          defer: true,
          appendTo: "head",
        }}
      > */}
        <BrowserRouter>
          <RedirectMiddleware>
            <MyRouter />
          </RedirectMiddleware>
        </BrowserRouter>
        <AppModal />
      {/* </GoogleReCaptchaProvider> */}
    </>
  );
}

export default App;
